import React, { useEffect, useState } from "react";
import { Segmented } from "antd";
import utils from "utils";
import MyAvailability from "./MyAvailability";
import MyAvailabilityNewVersion from "./MyAvailabilityNewVersion";
import "./MyAvailabilitySwitch.scss";
import TabComponent from "Components/TabComponent";
function MyAvailabilitySwitch(props) {
  const [selectedTab, setSelectedTab] = useState("my-availability");
  const [formActionState, formAction] = useState(false);
  // useEffect(()=>{props?.formAction(formActionState)},[formActionState])
  useEffect(() => {
    if (props?.formAction && typeof props?.formAction == "function") {
      props.formAction(formActionState);
    }
  }, [formActionState]);
  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };
  const unsavedPopup = (key) => {
    utils.Modal(true, {
      width: "650px",
      // closable: false,
      content: (
        <div className="finish-Consult-Modal">
          <div className="finish-header">Switch Tab</div>
          <div className="finish-wrapper">
            <div className="finish-title">
              There are unsaved changes. Are you sure to switch Tab?
            </div>
            <div className="finish-btns">
              <button
                className="action-yes"
                onClick={() => {
                  setSelectedTab(key), utils.Modal(false);
                  formActionState(false);
                }}
              >
                Yes
              </button>
              <button
                className="action-no"
                onClick={() => {
                  utils.Modal(false);
                }}
              >
                No
              </button>
            </div>
          </div>
        </div>
      ),
    });
  };
  let config = [
    {
      label: "My Availability",
      value: "my-availability",
      render: (props) => (
        <div style={{ padding: "26px" }}>
          <MyAvailability />
        </div>
      ),
    },
    {
      label: "My Availability (Beta Version)",
      value: "my-availability-new-version",
      render: (props) => (
        <div style={{ padding: "26px" }}>
          <MyAvailabilityNewVersion />
        </div>
      ),
    },
  ];
  return (
    <div className="myAvailabilitySwitch">
      <div
        className="myAvailabilitySwitchHeader"
        // style={{
        //   display: "flex",
        //   alignItems: "center",
        //   justifyContent: "center",
        // }}
      >
        {/* <Segmented
          size="large"
          value={selectedTab}
          onChange={formActionState ? unsavedPopup : handleTabChange}
          options={[
            {
              label: "My Availability",
              value: "my-availability",
            },
            {
              label: "My Availability (Beta Version)",
              value: "my-availability-new-version",
            },
          ]}
        /> */}
        <TabComponent
          className="profile-list-tab-content"
          defaultActiveKey={selectedTab}
          destroyInactiveTabPane={true}
          config={config || []}
          // onChange={this.handleTabChange.bind(this)}
          onChange={formActionState ? unsavedPopup : handleTabChange}
        />
      </div>
      {/* 
      <div style={{ paddingTop: "30px" }} className="">
        {selectedTab == "my-availability" && <MyAvailability {...props} />}
        {selectedTab == "my-availability-new-version" && (
          <MyAvailabilityNewVersion {...props} />
        )}
      </div> */}
    </div>
  );
}

export default MyAvailabilitySwitch;
